import ModelBase, {IModelBase} from '@/models/ModelBase'
import Tag, {ITag} from '@/models/Tag'
import {PostStatus} from '@/models/Post'
import { KeyPair } from '@/types/KeyPair'
import Recruit, {IRecruit} from '@/models/Recruit'

export type TelecommuteType = 'none' | 'limit' | 'full'
export type SalarySystem = 'none' | 'year' | 'month'

export interface IJob extends IModelBase {
  recruit?: IRecruit
  recruit_id?: number
  tag?: ITag
  title?: string
  description?: string
  contract_type?: string
  qualification?: string
  salary?: string
  salary_lower?: number
  salary_upper?: number
  welfare?: string
  hours?: string
  location?: string
  vacation?: string
  applicants?: string
  bonus?: string
  social_insurance?: string
  status: PostStatus
  telecommute_type: TelecommuteType
  salary_system: SalarySystem
}

export default class Job extends ModelBase {
  recruit?: Recruit
  recruit_id?: number
  tag?: Tag
  title?: string
  description?: string
  contract_type?: string
  qualification?: string
  salary?: string
  salary_lower?: number
  salary_upper?: number
  welfare?: string
  hours?: string
  location?: string
  vacation?: string
  applicants?: string
  bonus?: string
  social_insurance?: string
  status: PostStatus
  telecommute_type: TelecommuteType
  salary_system: SalarySystem

  constructor(defaults?: IJob) {
    super(defaults)
    if (defaults) {
      this.recruit = defaults.recruit ? new Recruit(defaults.recruit) : undefined
      this.recruit_id = defaults.recruit_id
      this.tag = defaults.tag ? new Tag(defaults.tag) : undefined
      this.title = defaults.title || ''
      this.description = defaults.description || ''
      this.contract_type = defaults.contract_type || ''
      this.qualification = defaults.qualification || ''
      this.salary = defaults.salary || ''
      this.salary_system = defaults.salary_system
      this.salary_lower = defaults.salary_lower
      this.salary_upper = defaults.salary_upper
      this.welfare = defaults.welfare || ''
      this.hours = defaults.hours || ''
      this.location = defaults.location || ''
      this.vacation = defaults.vacation || ''
      this.applicants = defaults.applicants
      this.bonus = defaults.bonus || ''
      this.social_insurance = defaults.social_insurance || ''
      this.status = defaults.status
      this.telecommute_type = defaults.telecommute_type || 'none'
    }
  }

  get tagCategory(): Tag {
    return this.tag.parent
  }

  toParams(): KeyPair {
    return {
      recruit_id: this.recruit_id,
      tag_id: this.tag.id,
      title: this.title,
      description: this.description,
      contract_type: this.contract_type,
      qualification: this.qualification,
      salary: this.salary,
      salary_system: this.salary_system,
      salary_lower: this.salary_lower,
      salary_upper: this.salary_upper,
      welfare: this.welfare,
      hours: this.hours,
      location: this.location,
      vacation: this.vacation,
      applicants: this.applicants,
      bonus: this.bonus,
      social_insurance: this.social_insurance,
      status: this.status,
      telecommute_type: this.telecommute_type
    }
  }
}
